import { CaseInfoBanner } from "src/components/case-info-banner/case-info-banner";
import { useCaseClosedViewProps } from "src/pages/case-landing/views/case-closed/case-closed-view-model";
import { PortalState } from "src/api/types/enums";

const CaseClosedView = ({state}: {state: PortalState}) => {
  const { bannerKey } = useCaseClosedViewProps(state);
  return <CaseInfoBanner translationKey={`caseInfoBanner.${bannerKey}`} />;
};

export default CaseClosedView;
